import axios from "axios"

// Custom Component
// import DoRefreshToken from '../components/SignIn/DoRefreshToken'
import SignOut from '../components/SignIn/SignOut'

const store = require('store')

const getSubmissionType = async () => {
	const getSubmissionType_api = "/submission/ui/type"
	let result

	try {
		let headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3005 + getSubmissionType_api,
			headers: headers,
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}

const getSubmissionStage = async () => {
	const getSubmissionStage_api = "/submission/ui/stage"
	let result

	try {
		let headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3005 + getSubmissionStage_api,
			headers: headers,
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const documentSubmissionSearch = async (searchProperty) => {
	const getSubmissionStage_api = "/submission"
	let params
	let result

	try {
		let headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		params = searchProperty

		result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3005 + getSubmissionStage_api,
			headers: headers,
			params: params
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const getDocumentSubmissionDetail = async (submissionSeq) => {
	const getDocumentSubmissionDetail_api = `/submission/${submissionSeq}`
	let result

	try {
		let headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3005 + getDocumentSubmissionDetail_api,
			headers: headers,
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const documentSubmissionModifySave = async (submissionSeq, params) => {
	const documentSubmissionModifySave_api = `/submission/${submissionSeq}`
	let result

	try {
		let headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		result = await axios({
			method: 'patch',
			url: process.env.REACT_APP_API_URL_3005 + documentSubmissionModifySave_api,
			headers: headers,
			data: params
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const documentSubmissionApproval = async (submissionSeq, params) => {
	const documentSubmissionApproval_api = `/submission/${submissionSeq}/approval`
	let result

	try {
		let headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		result = await axios({
			method: 'post',
			url: process.env.REACT_APP_API_URL_3005 + documentSubmissionApproval_api,
			headers: headers,
			data: params
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const getDocumentSubmissionType = async () => {
	const getDocumentSubmissionType_api = "/submission/ui/type"
	let result

	try {
		let headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3005 + getDocumentSubmissionType_api,
			headers: headers,
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const getDocumentSubmissionForm = async (formSeq) => {
	const getDocumentSubmissionForm_api = `/form/${formSeq}`
	let result

	try {
		let headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3004 + getDocumentSubmissionForm_api,
			headers: headers,
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


const documentSubmissionCreate = async (params) => {
	const documentSubmissionCreate_api = "/submission"
	let result

	try {
		let headers = {
			"Authorization": "Bearer " + store.get('access_token'),
			"site": store.get('site'),
			"locale": store.get('locale')
		}

		result = await axios({
			method: 'post',
			url: process.env.REACT_APP_API_URL_3005 + documentSubmissionCreate_api,
			headers: headers,
			data: params
		})

		return result.data
	}
	catch(error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			}
			else {
				throw new Error(error)
			}
		}
		catch(error) {
			throw new Error(error)
		}
	}
}


export {
	getSubmissionType,
	getSubmissionStage,
	documentSubmissionSearch,
	getDocumentSubmissionDetail,
	documentSubmissionModifySave,
	documentSubmissionApproval,
	getDocumentSubmissionType,
	getDocumentSubmissionForm,
	documentSubmissionCreate
}